(function HotelEngine($, Adzuki)
{
	'use strict';

	const SORT_OPTIONS = new Set([
		'topPicks',
		'priceAsc',
		'priceDesc',
		'ratingDesc',
		'ratingAsc',
		'distanceAsc',
		'distanceDesc',
	]);

	const splitFiltersAndSort = (filters) => {
		if (!filters || typeof filters !== 'object') {
			return {
				filters: null,
				sort   : 'topPicks',
			};
		}

		const { sort, ...filtersOnly } = filters;
		const resolvedSort = (typeof sort === 'string' && SORT_OPTIONS.has(sort)) ? sort : 'topPicks';

		return {
			filters: Object.keys(filtersOnly).length > 0 ? filtersOnly : null,
			sort   : resolvedSort,
		};
	};

	const resolveSearchSort = (datasetSort, storedFiltersSort, storedSearchSort) => {
		if (datasetSort !== 'topPicks') {
			return datasetSort;
		}

		if (storedFiltersSort !== 'topPicks') {
			return storedFiltersSort;
		}

		if (typeof storedSearchSort === 'string' && SORT_OPTIONS.has(storedSearchSort)) {
			return storedSearchSort;
		}

		return 'topPicks';
	};

	const appConfig = {
		data() {
			return {
				baseUri           : Adzuki.base_uri,
				siteUrl           : Adzuki.current_website || window.location.origin,
				savingsBadgeModel : Adzuki.savingsBadgeModel,
				savingsValueFormat: Adzuki.savingsValueFormat,
				showRateBadges    : Adzuki.showRateBadges,
				showComparison    : Adzuki.showComparison,
				payLaterActive    : Adzuki.payLaterActive,
				componentProps    : {},
				coordinates       : {},
				hotels            : [],
				filteredHotels    : [],
				formData          : {
					locationSearch: '',
					locationRadius: '',
					checkIn       : '',
					checkOut      : '',
					numRooms      : 1,
					rooms         : []
				},
				hotelsBatchSize       : 25,
				hotelsToCompare       : [],
				isLoading             : true,
				isLoadingHotel        : false,
				selectedSortOption    : 'topPicks',
				numNights             : 0,
				showMap               : false,
				showModal             : false,
				modalTitle            : '',
				modalProps            : {},
				componentToRender     : null,
				showSearch            : true,
				skipRoomsWatcher      : false,
				totalRooms            : 0,
				visibleHotels         : [],
				poiMapHotel           : null,
				showPageSearch        : false,
				filterList            : [],
				searchFilters         : {},
				updatedFilters        : [],
				showFilterRow         : false,
				showFeatured          : false,
				featuredCriteria      : '',
				showBadgeModal        : false,
				shouldAutoSubmit      : false,
				hotelsLoadedFromCache : false,
				datasetSearchCriteria : null,
				datasetSearchLocation : null,
				datasetSearchFilters  : null,
				resolvedSearchCriteria: null,
				resolvedSearchLocation: null,
				pendingSharedFilters  : null,
				showAlert             : false,
				alertTitle            : null,
				alertMessage          : null,
				alertType             : null,
				redirectAfterAlert    : false,
				pendingToast          : null
			};
		},
		methods: {
			clearData() {
				sessionStorage.removeItem('formData');
				sessionStorage.removeItem('coordinates');
				sessionStorage.removeItem('searchCriteria');
				sessionStorage.removeItem('locationSearch');
				sessionStorage.removeItem('searchLocation');
				sessionStorage.removeItem('searchFilters');
				sessionStorage.removeItem('searchSort');
				sessionStorage.removeItem('giataId');
				sessionStorage.removeItem('selectedHotel');
				sessionStorage.removeItem('selectedRoom');
				sessionStorage.removeItem('rate_select_string');

				this.$hotelDb.deleteDB();

				this.formData = {
					locationSearch: '',
					locationRadius: '',
					checkIn       : '',
					checkOut      : '',
					numRooms      : 1,
					rooms         : [],
				};
				this.coordinates = {};

				this.formData.rooms = Array.from({length: this.formData.numRooms}, (_, index) => ({
					roomNumber  : index + 1,
					numAdults   : 2,
					numChildren : 0,
					childrenAges: []
				}));

				this.showSearch            = true;
				this.hotels                = [];
				this.searchFilters         = {};
				this.filterList            = [];
				this.showFilterRow         = false;
				this.datasetSearchFilters  = null;
				this.pendingSharedFilters  = null;
				this.selectedSortOption    = 'topPicks';

				const sortComponent = this.$refs.heSortHotels;

				if (sortComponent && typeof sortComponent.resetSort === 'function') {
					sortComponent.resetSort();
				}
			},
			parseLocalDate(dateStr) {
				if (!dateStr || typeof dateStr !== 'string') {
					return null;
				}

				const parsedDate = new Date(`${dateStr}T12:00:00`);

				return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
			},
			isValidStayDates(checkIn, checkOut) {
				const checkInDate  = this.parseLocalDate(checkIn);
				const checkOutDate = this.parseLocalDate(checkOut);

				if (!checkInDate || !checkOutDate) {
					return false;
				}

				return checkOutDate > checkInDate;
			},
			clearComparisonInput(hotel_id) {
				const checkbox = document.querySelector(`input[data-hotel-id="${hotel_id}"]`);
				if (checkbox) {
					checkbox.checked = false;
				}
			},
			truncateString(string, maxLength) {
				if (string) {
					if (string.length > maxLength) {
						return string.substring(0, maxLength) + '...';
					}
					return string;
				}
				return null;
			},
			displaySpecialtyRateCode(code) {
				return Adzuki.HotelEngine.displaySpecialtyRateCode(code);
			},
			hotelPrices(hotel) {
				return Adzuki.HotelEngine.computeRatePrices(hotel, {
					numNights: this.numNights,
					numRooms : this.totalRooms,
				});
			},
			hotelTotalPrice(hotel) {
				return this.hotelPrices(hotel).totalCost;
			},
			handleScrollLoad() {
				const sentinel = document.querySelector('.hotel-load-more');

				if (!sentinel) {
					console.error('Sentinel element not found');
					return;
				}

				// Disconnect any existing observer
				if (this.scrollObserver) {
					this.scrollObserver.disconnect();
				}

				// Create new observer
				this.scrollObserver = new IntersectionObserver((entries) => {
					entries.forEach(entry => {
						if (entry.isIntersecting && !this.isLoadingHotel) {
							this.loadMoreHotels();
						}
					});
				}, {
					rootMargin: '200px'
				});

				this.scrollObserver.observe(sentinel);
			},
			handleSearchStart(options = {}) {
				this.hotels                = [];
				this.hotelsLoadedFromCache = false;
				this.isLoading             = true;
				this.showSearch            = false;

				if (!options.preserveFilters) {
					this.resetSearchFilters();
				}
			},
			resetSearchFilters() {
				sessionStorage.removeItem('searchFilters');
				sessionStorage.removeItem('searchSort');
				this.pendingSharedFilters = null;
				this.datasetSearchFilters = null;
				this.searchFilters         = {};
				this.filterList            = [];
				this.showFilterRow         = false;
				this.updatedFilters        = [];
				this.selectedSortOption    = 'topPicks';

				const filterComponent = this.$refs.heSearchFilters;

				if (filterComponent && typeof filterComponent.clearFilters === 'function') {
					filterComponent.clearFilters();
				}

				const sortComponent = this.$refs.heSortHotels;

				if (sortComponent && typeof sortComponent.resetSort === 'function') {
					sortComponent.resetSort();
				}
			},
			handleSortChanged(sortOption) {
				const resolvedSort = (typeof sortOption === 'string' && SORT_OPTIONS.has(sortOption))
					? sortOption
					: 'topPicks';

				this.selectedSortOption = resolvedSort;

				if (resolvedSort === 'topPicks') {
					sessionStorage.removeItem('searchSort');
				} else {
					sessionStorage.setItem('searchSort', resolvedSort);
				}
			},
			hasFeatured() {
				this.showFeatured = true;
			},
			initializeVisibleHotels() {
				this.visibleHotels = this.filteredHotels.slice(0, this.hotelsBatchSize);
			},
			loadMoreHotels() {
				if (this.isLoadingHotel || this.visibleHotels.length >= this.filteredHotels.length) {
					return;
				}

				this.isLoadingHotel = true;

				const nextBatch = this.filteredHotels.slice(
					this.visibleHotels.length,
					this.visibleHotels.length + this.hotelsBatchSize
				);

				// Add new batch to visibleHotels
				setTimeout(() => {
					this.visibleHotels.push(...nextBatch);
					this.isLoadingHotel = false; // Reset loading flag
					if (this.visibleHotels.length < this.filteredHotels.length) {
						this.$nextTick(() => {
							this.handleScrollLoad();
						});
					}

				}, 300); // Simulated delay for smoother UX
			},
			toggleHotelComparison(hotel) {
				const index = this.hotelsToCompare.findIndex(
					(h) => h.hotel_id === hotel.hotel_id
				);

				if (index === -1) {
					this.hotelsToCompare.push(hotel);
				} else {
					this.hotelsToCompare.splice(index, 1);
				}

				const checkbox = document.querySelector(`input[data-hotel-id="${hotel.hotel_id}"]`);
				if (checkbox) {
					checkbox.checked = index === -1;
				}

			},
			toggleMap() {
				this.showMap     = !this.showMap;
				this.poiMapHotel = null;
			},
			buildHotelMapMarker(hotel) {
				const prices = this.hotelPrices(hotel);

				return {
					lat        : parseFloat(hotel.lat),
					lng        : parseFloat(hotel.lng),
					title      : hotel.name,
					content    : hotel.full_address || 'No address available',
					hotel_id   : hotel.hotel_id,
					image      : hotel.metadata?.images?.[0]?.thumbnail_url || this.baseUri + '/images/map-back.png',
					address    : hotel.full_address,
					description: hotel.description,
					star_rating: hotel.star_rating,
					price      : prices.sellingPrice > 0 ? prices.per_night_per_room : 'Hotel Unavailable',
				};
			},
			togglePoiMap(hotel) {
				this.showMap     = !this.showMap;
				this.poiMapHotel = this.showMap ? hotel : null;
			},
			closeModal() {
				this.showModal         = false;
				this.modalTitle        = '';
				this.modalProps        = {};
				this.componentToRender = null;
			},
			setFormData(data) {
				this.formData = data;
			},
			setCoordinates(coordinates) {
				this.coordinates = coordinates && typeof coordinates === 'object' ? coordinates : {};
			},
			syncCoordinatesFromSession() {
				try {
					const storedCoordinates = sessionStorage.getItem('coordinates');

					if (!storedCoordinates) {
						return;
					}

					const parsed = JSON.parse(storedCoordinates);

					if (parsed && typeof parsed === 'object') {
						this.coordinates = parsed;
					}
				} catch (e) {
					// Ignore invalid session data
				}
			},
			toggleSearch() {
				this.showPageSearch = !this.showPageSearch;
			},
			toggleFeatured() {
				this.showFeatured = !this.showFeatured;
			},
			fetchAmenityList() {
				fetch(this.baseUri + '/HotelEngine/amenityList')
					.then((response) => {
						if (!response.ok) {
							throw new Error(`HTTP error! Status: ${response.status}`);
						}
						return response.json();
					})
					.then((data) => {
						if (data) {
							this.amenityList = Object.values(data);
						} else {
							console.error('Invalid data format from backend.');
						}
					})
					.catch((error) => {
						console.error('Error fetching hotels:', error);
					});
			},
			showPoiModal(hotel) {
				this.showModal = true;

				const startingPoint = [this.buildHotelMapMarker(hotel)];

				this.modalProps = {
					divName    : 'poi-map',
					mapInfo    : startingPoint,
					showMap    : true,
					hasPoi     : true,
					coordinates: this.coordinates,
					radius     : Number(this.formData.locationRadius),
				};

				this.componentToRender = Adzuki.VueComponents.AdzukiGoogleMap;

			},
			buildCombinedSearchKey(criteriaInput, locationInput = null) {
				let criteria = criteriaInput;
				let location = locationInput;

				if (typeof criteria === 'string') {
					try {
						criteria = JSON.parse(criteria);
					} catch (e) {
						return '';
					}
				}

				if (typeof location === 'string') {
					try {
						location = JSON.parse(location);
					} catch (e) {
						location = null;
					}
				}

				if (!criteria || typeof criteria !== 'object') {
					return '';
				}

				// If criteria already contains location, keep it.
				// If not, merge provided location.
				const combined = {
					check_in : criteria.check_in,
					check_out: criteria.check_out,
					rooms    : Array.isArray(criteria.rooms) ? criteria.rooms : [],
					location : (criteria.location && typeof criteria.location === 'object') || !(location && typeof location === 'object') ? criteria.location : location,
				};

				if (!combined.location) {
					return '';
				}

				return JSON.stringify(combined);
			},
			loadHotels(hotels) {
				const storedSearchCriteria = sessionStorage.getItem('searchCriteria');
				const storedSearchLocation = sessionStorage.getItem('searchLocation');

				this.syncCoordinatesFromSession();
				this.featuredCriteria = this.buildCombinedSearchKey(storedSearchCriteria, storedSearchLocation);

				if (Array.isArray(hotels)) {
					this.hotels         = hotels;
					this.filteredHotels = hotels;
				} else {
					console.error('loadHotels received non-array:', hotels);
					this.hotels = [];
					this.filteredHotels = [];
				}

				if (
					this.pendingSharedFilters
					&& typeof this.pendingSharedFilters === 'object'
					&& Object.keys(this.pendingSharedFilters).length > 0
				) {
					this.datasetSearchFilters = this.pendingSharedFilters;
					this.setFilterList(this.pendingSharedFilters);
					this.pendingSharedFilters = null;
				}

				this.isLoading = false;

				this.initializeVisibleHotels();

				this.$nextTick(() => {
					this.handleScrollLoad();
				});
			},
			loadFilteredHotels(hotels) {
				this.filteredHotels = hotels;

				this.$nextTick(() => {
					this.initializeVisibleHotels();
					this.handleScrollLoad();
				});
			},
			setFilterList(filterList) {
				const normalizedFilters = filterList && typeof filterList === 'object' ? { ...filterList } : {};

				if (normalizedFilters.sort) {
					delete normalizedFilters.sort;
				}

				this.searchFilters = normalizedFilters;

				if (Object.entries(this.searchFilters).length >= 1) {
					this.showFilterRow = true;
					sessionStorage.setItem('searchFilters', JSON.stringify(this.searchFilters));
				} else {
					this.showFilterRow = false;
					sessionStorage.removeItem('searchFilters');
				}

				const processedFilters = [];

				Object.entries(this.searchFilters).forEach(([parentKey, value]) => {

					if (parentKey === 'rateRangeSearch' && value) {
						if ((value.min && value.min !== 0) || (value.max && value.max !== 0)) {
							processedFilters.push({
								key  : 'rateRange',
								value: `$${value.min} - $${value.max}`
							});
							return;
						}
					}

					if (parentKey === 'starSearch' && value) {
						value.forEach(item => {
							processedFilters.push({
								key  : 'starSearch',
								value: `${Math.floor(parseFloat(item))} Stars`
							});
						});
						return;
					}

					if (Array.isArray(value) && value.length > 0) {
						value.forEach(item => {
							processedFilters.push({
								key  : parentKey,
								value: item
							});
						});
					}
				});

				this.filterList = processedFilters;
			},
			removeFilter(filter) {
				const index = this.filterList.findIndex(f => f.key === filter.key && f.value === filter.value);

				if (index !== -1) {
					this.updatedFilters.push(filter);
					this.filterList.splice(index, 1);
				}

				if (this.filterList.length === 0) {
					this.$nextTick(() => {
						this.showFilterRow = false;
						this.updatedFilters = [];
					});
				}
			},
			async checkStoredHotels(searchCriteria) {
				try {
					const storedData = await this.$hotelDb.getHotels(searchCriteria);

					// Handle both string and object returns from IndexedDB
					let storedHotels = [];

					if (typeof storedData === 'string' && storedData.length > 0) {
						storedHotels = JSON.parse(storedData);
					} else if (Array.isArray(storedData) && storedData.length > 0) {
						storedHotels = storedData;
					} else if (storedData && typeof storedData === 'object' && !Array.isArray(storedData)) {
						if (Array.isArray(storedData.hotels)) {
							storedHotels = storedData.hotels;
						} else if (storedData.data && Array.isArray(storedData.data)) {
							storedHotels = storedData.data;
						} else {
							storedHotels = Object.values(storedData);
						}
					}

					if (Array.isArray(storedHotels) && storedHotels.length > 0) {
						this.showSearch            = false;
						this.hotelsLoadedFromCache = true;
						this.loadHotels(storedHotels);
						return true;
					}

					console.warn('No valid hotels found in IndexedDB');
					return false;
				} catch (error) {
					console.error('Error loading hotels from IndexedDB:', error);
					this.handleGetHotelsError('Saved search results could not be loaded. Please run your search again.');
					return false;
				}
			},
			hasSharedSearchParams() {
				return Boolean(this.datasetSearchCriteria && this.datasetSearchLocation);
			},
			hasRestorableSearchParams(criteria, location) {
				return Boolean(
					criteria
					&& criteria.check_in
					&& criteria.check_out
					&& location
					&& location.lat !== undefined
					&& location.lat !== null
					&& location.lng !== undefined
					&& location.lng !== null
				);
			},
			canAutoSubmitSearch() {
				if (this.hasHotels || this.hotelsLoadedFromCache) {
					return false;
				}

				return this.hasSharedSearchParams() ||
					this.hasRestorableSearchParams(
						this.resolvedSearchCriteria,
						this.resolvedSearchLocation
					);
			},
			async selectHotel(hotel) {
				sessionStorage.removeItem('selectedHotel');
				sessionStorage.setItem('giataId', hotel.hotel_id);

				if (Adzuki.app === 'Web') {
					console.log('Redirecting to hotelDetails page', hotel.hotel_id);
					window.location.href = this.baseUri + '/HotelSearch/hotelDetails/' + hotel.hotel_id;
				} else {
					window.location.href = this.baseUri + '/HotelEngine/hotelDetails/' + hotel.hotel_id;
				}
			},
			async reverseGeocodeLocation(lat, lng) {
				const url = `${this.baseUri}/HotelEngine/getCityByCoords/${lat}/${lng}`;
				try {
					const response = await fetch(url);
					if (!response.ok) {
						console.error(`Failed to fetch city: ${response.statusText}`);
						return null;
					}
					const data = await response.json();
					if (!data.status || !data.results) {
						return null;
					}
					return data.results;
				} catch (error) {
					console.error('Error fetching City from coords:', error);
					return null;
				}
			},
			triggerAutoSubmit() {
				if (!this.canAutoSubmitSearch()) {
					this.shouldAutoSubmit = false;
					return;
				}

				const searchFormComponent = this.$refs.heSearchForm;

				if (!searchFormComponent) {
					console.warn('Search form component not found in refs');
					return;
				}

				console.log('Parent data ready:', {
					parentCheckIn : this.formData.checkIn,
					parentCheckOut: this.formData.checkOut,
					parentLat     : this.coordinates.lat,
					parentLng     : this.coordinates.lng,
				});

				console.log('Child component data:', {
					checkIn : searchFormComponent.formData?.checkIn,
					checkOut: searchFormComponent.formData?.checkOut,
					lat     : searchFormComponent.coordinates?.lat,
					lng     : searchFormComponent.coordinates?.lng,
				});

				// Verify all required data exists in BOTH parent and child
				if (!this.formData ||
					!this.formData.checkIn ||
					!this.formData.checkOut ||
					!this.coordinates ||
					!this.coordinates.lat ||
					!this.coordinates.lng)
				{
					console.warn('Parent data incomplete');
					return;
				}

				if (!searchFormComponent.formData ||
					!searchFormComponent.formData.checkIn ||
					!searchFormComponent.formData.checkOut ||
					!searchFormComponent.coordinates ||
					!searchFormComponent.coordinates.lat ||
					!searchFormComponent.coordinates.lng)
				{
					console.warn('Child component data incomplete, retrying in 300ms');
					setTimeout(() => {
						if (!this.canAutoSubmitSearch()) {
							this.shouldAutoSubmit = false;
							return;
						}

						this.triggerAutoSubmit();
					}, 300);
					return;
				}

				console.log('All data ready! Auto-submitting search form');
				this.shouldAutoSubmit = false;
				searchFormComponent.submitForm({ preserveFilters: true });
			},
			openAlert(type, title, message) {
				this.showAlert    = true;
				this.alertTitle   = title;
				this.alertMessage = message;
				this.alertType    = type;
			},
			getSearchResultsUrl() {
				if (Adzuki.app === 'Web') {
					return `${this.baseUri}/HotelSearch/searchResults`;
				}

				return `${this.baseUri}/HotelEngine/searchResults`;
			},
			handleGetHotelsError(message) {
				this.redirectAfterAlert = true;
				this.openAlert(
					'error',
					'Unable to load hotels',
					message || 'Saved search results could not be loaded. Please run your search again.'
				);
			},
			closeAlert() {
				this.showAlert = false;

				if (this.redirectAfterAlert) {
					this.redirectAfterAlert = false;
					window.location.href = this.getSearchResultsUrl();
				}
			},
			openToast(status, message, options) {
				const toastComponent = this.$refs && this.$refs.toast;

				if (!toastComponent || typeof toastComponent.openToast !== 'function') {
					this.pendingToast = {
						status,
						message,
						options: options || {}
					};
					return;
				}

				toastComponent.openToast(status, message, options || {});
			},
			decodeUrlParam(encoded) {
				if (!encoded || typeof encoded !== 'string') {
					return '';
				}

				let base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
				const pad  = base64.length % 4;

				if (pad > 0) {
					base64 += '='.repeat(4 - pad);
				}

				return base64;
			},
			encodeUrlParam(data) {
				const json = JSON.stringify(data);

				return btoa(json)
					.replace(/\+/g, '-')
					.replace(/\//g, '_')
					.replace(/[=]+$/, '');
			},
			buildSearchCriteriaPayload() {
				const structuredRooms = (this.formData.rooms || []).map((room) => ({
					num_adults  : String(room.numAdults ?? 1),
					num_children: String(room.numChildren ?? 0),
					child_ages  : (room.childrenAges || []).map((age) => String(age))
				}));

				return {
					check_in : this.formData.checkIn,
					check_out: this.formData.checkOut,
					rooms    : structuredRooms
				};
			},
			buildSearchLocationPayload() {
				return {
					lat   : this.coordinates.lat,
					lng   : this.coordinates.lng,
					radius: this.formData.locationRadius
				};
			},
			buildShareUrl() {
				const criteria = this.buildSearchCriteriaPayload();
				const location = this.buildSearchLocationPayload();
				const filters  = this.searchFilters && typeof this.searchFilters === 'object'
					? { ...this.searchFilters }
					: {};

				if (this.selectedSortOption && this.selectedSortOption !== 'topPicks') {
					filters.sort = this.selectedSortOption;
				}

				if (!criteria.check_in || !criteria.check_out || !location.lat || !location.lng) {
					return '';
				}

				const franchiseUrl = (this.siteUrl || window.location.origin).replace(/\/$/, '');

				return `${franchiseUrl}${this.baseUri}/HotelSearch/searchResults/${this.encodeUrlParam(criteria)}/${this.encodeUrlParam(location)}/${this.encodeUrlParam(filters)}`;
			},
			async shareSearch() {
				const shareUrl = this.buildShareUrl();

				if (!shareUrl) {
					this.openAlert('warning', 'Unable to share', 'Search details are incomplete. Please run a search first.');
					return;
				}

				try {
					if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
						await navigator.clipboard.writeText(shareUrl);
					} else {
						const textarea = document.createElement('textarea');
						textarea.value = shareUrl;
						textarea.setAttribute('readonly', '');
						textarea.style.position = 'absolute';
						textarea.style.left = '-9999px';
						document.body.appendChild(textarea);
						textarea.select();
						document.execCommand('copy');
						document.body.removeChild(textarea);
					}

					this.openAlert(
						'success',
						'Link copied',
						'The share link has been copied to your clipboard.'
					);
				} catch (error) {
					console.error('Unable to copy share link:', error);
					this.openAlert('info', 'Share this search', shareUrl);
				}
			},
			showReviews(hotel) {
				this.modalTitle = '';
				this.modalProps = {
					giataId        : Number(hotel.hotel_id),
					hotelName      : hotel.name,
					showCloseFooter: true,
				};
				this.componentToRender = Vue.markRaw(Adzuki.VueComponents.HotelEngineReviews);
				this.showModal = true;
			}
		},
		computed: {
			totalVisibleHotels() {
				return this.visibleHotels.length;
			},
			hasHotels() {
				return this.hotels && this.hotels.length > 0;
			},
			totalGuests() {
				return this.formData.rooms.reduce((total, room) => {
					const adults   = parseInt(room.numAdults) || 0;
					const children = parseInt(room.numChildren) || 0;

					return total + adults + children;
				}, 0);
			},
			mapInfo() {
				const hotelsArray = Array.isArray(this.filteredHotels) ? this.filteredHotels : [];

				return hotelsArray.map(hotel => this.buildHotelMapMarker(hotel));
			},
			mapProps() {
				if (this.poiMapHotel) {
					return {
						mapTitle   : this.poiMapHotel.name,
						divName    : 'hotels-map',
						mapInfo    : [this.buildHotelMapMarker(this.poiMapHotel)],
						showMap    : this.showMap,
						hasPoi     : true,
						coordinates: this.coordinates,
						radius     : Number(this.formData.locationRadius),
					};
				}

				return {
					divName: 'hotels-map',
					mapInfo: this.mapInfo,
					showMap: this.showMap,
					hasPoi : false,
				};
			},
		},
		watch: {
			shouldAutoSubmit(newVal) {
				if (newVal === true) {
					// Give child component time to mount and receive props
					this.$nextTick(() => {
						setTimeout(() => {
							if (!this.canAutoSubmitSearch()) {
								this.shouldAutoSubmit = false;
								return;
							}

							this.triggerAutoSubmit();
						}, 1000); // Increased to 1 second
					});
				}
			}
		},
		provide() {
			return {
				openAlert: this.openAlert,
				openToast: this.openToast,
			};
		},
		async mounted() {
			const flashRaw = sessionStorage.getItem('hotelSearchFlash');

			if (flashRaw) {
				sessionStorage.removeItem('hotelSearchFlash');

				try {
					const flash = JSON.parse(flashRaw);

					if (flash?.message) {
						this.openAlert(
							flash.type || 'error',
							flash.title || 'Notice',
							flash.message
						);
					}
				} catch (flashError) {
					console.error('Unable to show hotel search flash:', flashError);
				}
			}

			try {
				const container = document.getElementById('he-search-results');
				const parseJsonSafe = (value) => {
					if (!value || typeof value !== 'string') {
						return null;
					}

					try {
						return JSON.parse(value);
					} catch (e) {
						return null;
					}
				};

				const decodeDatasetParam = (value) => {
					if (!value || typeof value !== 'string') {
						return '';
					}

					try {
						return atob(this.decodeUrlParam(value));
					} catch (e) {
						return '';
					}
				};

				const datasetSearchCriteria = parseJsonSafe(decodeDatasetParam(container?.dataset?.searchCriteria));
				const datasetSearchLocation = parseJsonSafe(decodeDatasetParam(container?.dataset?.selectedLocation));
				const datasetSearchFilters  = parseJsonSafe(decodeDatasetParam(container?.dataset?.selectedFilters));
				const datasetLoggedIn       = (container && container.dataset && container.dataset?.loggedIn ? container.dataset.loggedIn : '');

				const datasetFiltersAndSort = splitFiltersAndSort(datasetSearchFilters);

				this.datasetSearchCriteria = datasetSearchCriteria;
				this.datasetSearchLocation = datasetSearchLocation;
				this.datasetSearchFilters  = datasetFiltersAndSort.filters;

				const storedFormData        = parseJsonSafe(sessionStorage.getItem('formData'));
				const storedCoordinates     = parseJsonSafe(sessionStorage.getItem('coordinates'));
				const storedSearchCriteria  = parseJsonSafe(sessionStorage.getItem('searchCriteria'));
				const storedSearchLocation  = parseJsonSafe(sessionStorage.getItem('searchLocation'));
				const storedSearchFilters   = parseJsonSafe(sessionStorage.getItem('searchFilters'));
				const storedSearchSort      = sessionStorage.getItem('searchSort');
				const storedLoggedIn        = sessionStorage.getItem('loggedIn');

				const resolvedLoggedIn        = datasetLoggedIn || storedLoggedIn;
				const resolvedFormData       = storedFormData;
				const resolvedCoordinates    = storedCoordinates;
				const resolvedSearchCriteria = datasetSearchCriteria || storedSearchCriteria;
				const resolvedSearchLocation = datasetSearchLocation || storedSearchLocation;
				let geocodedLocation         = null;

				this.resolvedSearchCriteria = resolvedSearchCriteria;
				this.resolvedSearchLocation = resolvedSearchLocation;

				if (!resolvedSearchCriteria && !resolvedSearchLocation) {
					window.location.href = this.baseUri + '/';
				}

				this.formData.rooms = [];

				if (resolvedLoggedIn) {
					this.setLoggedIn(true);
				}

				if (resolvedFormData) {
					this.skipRoomsWatcher = true;

					this.formData.locationSearch = resolvedFormData.locationSearch || '';
					this.formData.locationRadius = resolvedFormData.locationRadius || '';
					this.formData.checkIn        = resolvedFormData.checkIn || '';
					this.formData.checkOut       = resolvedFormData.checkOut || '';
					this.formData.numRooms       = Number(resolvedFormData.numRooms) || 1;

					(resolvedFormData.rooms || []).forEach((room, index) => {
						this.formData.rooms.push({
							roomNumber  : room.roomNumber || (index + 1),
							numAdults   : room.numAdults || 2,
							numChildren : room.numChildren || 0,
							childrenAges: room.childrenAges || []
						});
					});

					if (
						!this.formData.locationSearch
						&& resolvedSearchLocation
						&& resolvedSearchLocation.lat
						&& resolvedSearchLocation.lng
					) {
						geocodedLocation = await this.reverseGeocodeLocation(
							resolvedSearchLocation.lat,
							resolvedSearchLocation.lng
						);

						if (geocodedLocation) {
							this.formData.locationSearch = geocodedLocation.label ||
								geocodedLocation.city ||
								geocodedLocation.formatted_address ||
								'';
						}
					}

					if (!this.formData.locationRadius && resolvedSearchLocation?.radius) {
						this.formData.locationRadius = resolvedSearchLocation.radius;
					}

					this.skipRoomsWatcher = false;
				} else if (!resolvedFormData && (resolvedSearchLocation && resolvedSearchCriteria)) {

					// Build formData from searchCriteria and searchLocation when formData is null
					let resolvedLocationSearch = parseJsonSafe(sessionStorage.getItem('locationSearch'));

					if (resolvedLocationSearch === null) {
						resolvedLocationSearch = sessionStorage.getItem('locationSearch') || '';
					}

					if (!resolvedLocationSearch) {
						geocodedLocation = await this.reverseGeocodeLocation(resolvedSearchLocation.lat, resolvedSearchLocation.lng);
						if (geocodedLocation) {
							resolvedLocationSearch = geocodedLocation.label || geocodedLocation.city || geocodedLocation.formatted_address || '';
						}
					}

					this.skipRoomsWatcher = true;

					// Build location-based fields from searchLocation
					this.formData.locationRadius = resolvedSearchLocation.radius || 20;
					this.formData.locationSearch = resolvedLocationSearch || '';

					// Build date fields from searchCriteria
					this.formData.checkIn = resolvedSearchCriteria.check_in || '';
					this.formData.checkOut = resolvedSearchCriteria.check_out || '';

					// Build rooms array from searchCriteria
					if (Array.isArray(resolvedSearchCriteria.rooms) && resolvedSearchCriteria.rooms.length > 0) {
						this.formData.numRooms = resolvedSearchCriteria.rooms.length;

						resolvedSearchCriteria.rooms.forEach((room, index) => {
							this.formData.rooms.push({
								roomNumber  : index + 1,
								numAdults   : parseInt(room.num_adults) || 2,
								numChildren : parseInt(room.num_children) || 0,
								childrenAges: Array.isArray(room.child_ages) ? room.child_ages.map(age => parseInt(age)) : []
							});
						});
					} else {
						this.formData.numRooms = 1;
						this.formData.rooms.push({
							roomNumber  : 1,
							numAdults   : 2,
							numChildren : 0,
							childrenAges: []
						});
					}

					this.skipRoomsWatcher = false;
				}

				if (resolvedCoordinates) {
					this.coordinates = resolvedCoordinates;
				} else if (resolvedSearchLocation) {
					// Build coordinates from searchLocation when coordinates are not available
					this.coordinates = {
						lat   : resolvedSearchLocation.lat,
						lng   : resolvedSearchLocation.lng,
						radius: resolvedSearchLocation.radius
					};

					if (geocodedLocation) {
						this.coordinates.city         = geocodedLocation.city;
						this.coordinates.state_code   = geocodedLocation.state_code;
						this.coordinates.country_code = geocodedLocation.country_code;
					}
				}

				if (!this.isValidStayDates(this.formData.checkIn, this.formData.checkOut)) {
					return;
				}

				const checkInDate  = this.parseLocalDate(this.formData.checkIn);
				const checkOutDate = this.parseLocalDate(this.formData.checkOut);
				const timeDifference = checkOutDate - checkInDate;

				this.numNights  = timeDifference / (1000 * 60 * 60 * 24);
				this.totalRooms = this.formData.rooms.length;

				const storedFiltersAndSort  = splitFiltersAndSort(storedSearchFilters);
				const resolvedSearchFilters = datasetFiltersAndSort.filters || storedFiltersAndSort.filters;
				const resolvedSearchSort    = resolveSearchSort(
					datasetFiltersAndSort.sort,
					storedFiltersAndSort.sort,
					storedSearchSort
				);

				this.selectedSortOption = resolvedSearchSort;

				if (resolvedSearchFilters && Object.keys(resolvedSearchFilters).length > 0) {
					this.pendingSharedFilters = resolvedSearchFilters;
				}

				if (resolvedSearchCriteria) {
					const searchKey = this.buildCombinedSearchKey(
						resolvedSearchCriteria,
						resolvedSearchLocation
					);

					if (!searchKey) {
						console.warn('Unable to build search key for IndexedDB lookup');
						return;
					}

					const hotelsFromCache = await this.checkStoredHotels(searchKey);

					if (!hotelsFromCache && this.canAutoSubmitSearch()) {
						this.shouldAutoSubmit = true;
					}
				}
			} catch (error) {
				console.error('Error parsing local storage data:', error);
			}
		}
	};

	function initializeDB() {
		return new Promise((resolve, reject) => {
			const request = indexedDB.open('CpMaxxHotels', 1);

			request.onerror = (event) => {
				reject("Database error: " + event.target.error);
			};

			request.onsuccess = (event) => {
				resolve(event.target.result);
			};

			request.onupgradeneeded = (event) => {
				const db = event.target.result;
				if (!db.objectStoreNames.contains('hotels')) {
					db.createObjectStore('hotels');
				}
			};
		});
	}

$(document).ready(function documentReady() {
	const vueContainer = document.getElementById('he-search-results');
	 if (vueContainer) {
		 // initialize app and register components
		const app = Vue.createApp(appConfig);

		 const loggedInRef = Vue.ref(Boolean(vueContainer.dataset.loggedIn));

		 // Provide it to all child components
		 app.provide('$inject_loggedIn', loggedInRef);
		 app.provide('setLoggedIn', (val) => {
			 loggedInRef.value = val;
		 });

		app.config.globalProperties.$hotelDb = {
			async storeHotels(key, data) {
				const db = await initializeDB();
				return new Promise((resolve, reject) => {
					const transaction = db.transaction(['hotels'], 'readwrite');
					const store = transaction.objectStore('hotels');

					const request = store.put(data, key);

					request.onsuccess = () => {
						resolve('Hotels data stored successfully');
					};

					request.onerror = (event) => {
						reject('Error storing hotels data: ' + event.target.error);
					};
				});
			},
			async getHotels(key) {
				const db = await initializeDB();
				return new Promise((resolve, reject) => {
					const transaction = db.transaction(['hotels'], 'readonly');
					const store = transaction.objectStore('hotels');
					const request = store.get(key);

					request.onsuccess = () => {
						const result = request.result;

						if (Array.isArray(result)) {
							resolve(result);
						} else if (typeof result === 'string') {
							resolve(result);
						} else {
							resolve([]);
						}
					};

					request.onerror = (event) => {
						reject('Error retrieving hotels data: ' + event.target.error);
					};
				});
			},
			async deleteHotels(key) {
				const db = await initializeDB();
				return new Promise((resolve, reject) => {
					const transaction = db.transaction(['hotels'], 'readwrite');
					const store = transaction.objectStore('hotels');
					const request = store.delete(key);

					request.onsuccess = () => {
						resolve(`Hotels with key ${key} deleted successfully`);
					};

					request.onerror = (event) => {
						reject(`Error deleting hotels: ${event.target.error}`);
					};
				});
			},
			async deleteDB() {
				return new Promise((resolve, reject) => {
					const deleteRequest = indexedDB.deleteDatabase('CpMaxxHotels');

					deleteRequest.onsuccess = () => {
						resolve('Database successfully deleted');
					};

					deleteRequest.onerror = (event) => {
						reject(`Error deleting database: ${event.target.error}`);
					};

					deleteRequest.onblocked = () => {
						reject('Database deletion was blocked. Please close all other tabs with this site open');
					};
				});
			}
		};

		app.component('adzuki-alert', Adzuki.VueComponents.AdzukiAlert);
		app.component('adzuki-toast', Adzuki.VueComponents.AdzukiToast);
		app.component('adzuki-google-map', Adzuki.VueComponents.AdzukiGoogleMap);
		app.component('adzuki-loading', Adzuki.VueComponents.AdzukiLoading);
		app.component('adzuki-carousel', Adzuki.VueComponents.AdzukiCarousel);
		app.component('adzuki-modal', Adzuki.VueComponents.AdzukiModal);
		app.component('he-search-form', Adzuki.VueComponents.HotelEngineSearchForm);
		app.component('he-sort-hotels', Adzuki.VueComponents.HotelEngineSortHotels);
		app.component('he-room-config', Adzuki.VueComponents.HotelEngineRoomConfig);
		app.component('he-search-filters', Adzuki.VueComponents.HotelEngineSearchFilter);
		app.component('he-featured-properties', Adzuki.VueComponents.HotelEngineFeaturedProperties);
		app.component('he-comparison', Adzuki.VueComponents.HotelEngineComparison);
		app.component('he-rate-badge', Adzuki.VueComponents.HotelEngineRateBadge);
		app.component('he-value-badge', Adzuki.VueComponents.HotelEngineValueBadge);
		app.component('he-rate-details', Adzuki.VueComponents.HotelEngineRateDetails);
		app.component('he-reviews', Adzuki.VueComponents.HotelEngineReviews);

		app.directive('formatCurrency', Adzuki.VueDirectives.FormatCurrency);
		app.directive('formatDate', Adzuki.VueDirectives.FormatDate);
		app.mount('#he-search-results');
	}
	});
}(jQuery, window.Adzuki || {}));
